import { render, staticRenderFns } from "./feedback_page.vue?vue&type=template&id=a70ce6ce&scoped=true"
import script from "./feedback_page.vue?vue&type=script&lang=js"
export * from "./feedback_page.vue?vue&type=script&lang=js"
import style0 from "./feedback_page.vue?vue&type=style&index=0&id=a70ce6ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ce6ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a70ce6ce')) {
      api.createRecord('a70ce6ce', component.options)
    } else {
      api.reload('a70ce6ce', component.options)
    }
    module.hot.accept("./feedback_page.vue?vue&type=template&id=a70ce6ce&scoped=true", function () {
      api.rerender('a70ce6ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/feedback_page.vue"
export default component.exports